import { RouteType } from "types/RouteType";
import InstallationTrackingWizardStore from "./InstallationTrackingWizardStore";

const InstallationTrackingWizardRoute: RouteType = {
  name: "InstallationTrackingWizard",
  path: "/workflows/installation-tracking",
  layout: "/app",
  group: "Workflows",
  requiresAuth: true,
  requiresPermission: false,
  viewportCard: {
    header: {
      title: "Field Installation Tracking",
      component: () => import("./InstallationTrackingWizardHeader"),
      enableRefreshButton: true,
      enableBackButton: false,
    },
    body: {
      component: () => import("./InstallationTrackingWizard"),
      grayBackground: true,
    },
  },
  beforeEnter: async ({ rootStore }) => {
    if (!rootStore.installationTrackingWizardStore) {
      rootStore.installationTrackingWizardStore = new InstallationTrackingWizardStore(
        rootStore
      );
    }
    await rootStore.installationTrackingWizardStore.loadInitialData();
    return true;
  },
};

export default InstallationTrackingWizardRoute;